import xhr from 'xhr';

function loadUserData() {
  xhr.get('/stage-ajax/getUser', { json: true }, function(err, resp) {
    if (resp.body && resp.body.user) {
      // Hide login links
      const loginLinks = document.getElementsByClassName('js-login-link');
      for (let i = 0; i < loginLinks.length; i++) {
        loginLinks[i].classList.add('u-hidden');
      }

      // Show links to customer pages
      const accountLinks = document.getElementsByClassName('js-user-account-link');
      for (let a = 0; a < accountLinks.length; a++) {
        accountLinks[a].classList.remove('u-hidden');
      }

      // All security checks are made in backend, so this is fine (no secrets here)

      // Show content for logged in users
      const userLoggedInContent = document.getElementsByClassName('u-user--logged-in');
      for (let b = 0; b < userLoggedInContent.length; b++) {
        userLoggedInContent[b].classList.remove('u-hidden');
      }

      // Hide content for not logged in users
      const userNotLoggedInContent = document.getElementsByClassName('u-user--not-logged-in');
      for (let c = 0; c < userNotLoggedInContent.length; c++) {
        userNotLoggedInContent[c].classList.add('u-hidden');
      }

      // Set user full name into fields if found
      let fullName = resp.body.user.first_name ? resp.body.user.first_name : '';
      if (resp.body.user.last_name) {
        if (fullName) {
          fullName += ' ';
        }
        fullName += resp.body.user.last_name;
      }
      const userFullNameFields = document.getElementsByClassName('js-user-full-name');
      for (let d = 0; d < userFullNameFields.length; d++) {
        if (userFullNameFields[d].tagName === 'INPUT') {
          userFullNameFields[d].value = fullName;
        } else {
          userFullNameFields[d].innerHTML = fullName;
        }
      }
    }
  });
}

export {
  loadUserData
};
